<template>
  <div>
    <h2>Definitions</h2>

    <h3>Conservation Easement versus Restriction</h3>
    <p>In Massachusetts, a <i>Conservation Easement</i> and <i>Conservation Restriction</i> (CR) are synonymous.</p>
    <p>According to
      <i><a href="https://www.northfieldma.gov/sites/northfieldma/files/uploads/maconsrestrict08.pdf"
          target="_blank">The Massachusetts
          Conservation Restriction Handbook:</a></i>
    </p>
    <blockquote>
      <p>A conservation restriction (CR), <b>formerly known as a conservation easement</b>, is a means authorized by
        <a href="https://malegislature.gov/Laws/GeneralLaws/PartII/TitleI/Chapter184/Section31" target="_blank">Sections
          31-33 of Chapter 184 of the General Laws of the Commonwealth of Massachusetts</a>
        to limit the use of land in order
        to
        protect specified conservation values including the natural, scenic or open condition of the land.</p>
    </blockquote>

    <p>The Massachusetts <i>Executive Office of Energy and Environmental Affairs</i> (EEA) also states on its <a
        href="https://www.mass.gov/service-details/how-is-land-protected" target="_blank">web site:</a></p>
    <blockquote>
      <P>
        A CR (also known as a conservation easement) is a legal agreement between a landowner and a government agency or
        land trust that permanently protects open space by limiting future uses of the land, usually including the
        amount and type of development that can take place, but continues to leave the land in private ownership. The
        document conveys to the agency or land trust the right to monitor the property and enforce the terms of the
        agreement.
      </P>
    </blockquote>
  </div>
</template>

<script>

  export default {
    name: 'definitions',
    components: {
    }
  }
</script>